import React, { FC,useState,useEffect } from "react";
import { DEMO_CAR_LISTINGS } from "data/listings";
import { CarDataType } from "data/types";
//import Pagination from "shared/Pagination/Pagination";
import Heading2 from "components/Heading/Heading2";
import OneDaayTourCard from "./OneDayTourCard";
import FixDepCard from "./OneDayTourCard";
import { useLocation } from "react-router-dom";

export interface OneDayTourCardGridProps {
  className?: string;
  data?: CarDataType[];
}

const DEMO_DATA: CarDataType[] = DEMO_CAR_LISTINGS.filter((_, i) => i < 12);

const OneDayTourCardGrid: FC<OneDayTourCardGridProps> = ({
  className = "",
  data = DEMO_DATA,
}) => {
  const location = useLocation();
  const { city, country } = location.state || {};


  return (
    <div
      className={`nc-OneDayTourCardGrid ${className}`}
      data-nc-id="OneDayTourCardGrid"
    >
      <div className="mb-12">
        <div className="max-w-7xl mx-auto">
          <div className="mb-4">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/10 rounded-full border border-amber-500/20">
              <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
              <span className="text-xs sm:text-sm font-medium text-amber-600">
                {city}
              </span>
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight tracking-tight text-balance">
            {country}
          </h2>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
      {(data as any)?.map((car:any) =>  {
            return <OneDaayTourCard key={car.id} data={car}  />
      })}
      </div>
      {/* <div className="flex mt-16 justify-center items-center">
        <Pagination />
      </div> */}
    </div>
  );
};

export default OneDayTourCardGrid;
